// apps/web/src/features/dashboards/china-requests/labels.ts (#1589)
// Shared label maps + ordering constants for the dashboard sections.
// Status copy is REUSED from the requests namespace (no new status
// strings); refusal-reason copy is REUSED from `requests:refuseModal.*`.
import { RequestRefusalReason, RequestStatus } from '@magimp/shared';
import { STATUS_LABEL_KEYS } from '../../requests/display/index.js';

export { STATUS_LABEL_KEYS };

// Fixed lifecycle order for the status funnel. ARCHIVE is intentionally
// absent — the contract already excludes it from every metric.
export const FUNNEL_STATUS_ORDER: readonly RequestStatus[] = [
  RequestStatus.DRAFT,
  RequestStatus.READY_FOR_WORK,
  RequestStatus.IN_WORK,
  RequestStatus.PROCESSED,
  RequestStatus.RETURN,
  RequestStatus.SUCCESS,
  RequestStatus.REFUSED,
  RequestStatus.CLOSED,
];

// Enum → existing `requests:refuseModal.reason.*` key. Reuses the same
// copy the refuse modal renders; no new reason strings are introduced.
export const REFUSAL_REASON_LABEL_KEYS = {
  [RequestRefusalReason.QUOTE_RESPONSE_TOO_SLOW]: 'refuseModal.reason.quoteResponseTooSlow',
  [RequestRefusalReason.PRICE_NOT_ACCEPTED]: 'refuseModal.reason.priceNotAccepted',
  [RequestRefusalReason.CLIENT_UNRESPONSIVE]: 'refuseModal.reason.clientUnresponsive',
  [RequestRefusalReason.OTHER]: 'refuseModal.reason.other',
} as const satisfies Record<RequestRefusalReason, string>;
